import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  reassignCollector: '',
  page: 1,
  limit: 25,
};

const duplicateRecordsTableSlice = createSlice({
  name: 'duplicateRecordsTable',
  initialState,
  reducers: {
    setReassignCollector(state, action) {
      state.reassignCollector = action.payload;
    },
    setPage(state, action) {
      state.page = action.payload;
    },
    setLimit(state, action) {
      state.limit = action.payload;
    },
  },
});

export const { setReassignCollector, setPage, setLimit } =
  duplicateRecordsTableSlice.actions;

export const selectDuplicateRecordsTable = (state) => state.duplicateRecordsTable;

export default duplicateRecordsTableSlice.reducer;
